import { render, staticRenderFns } from "./ParcelleInfos.vue?vue&type=template&id=1794aa7a&scoped=true&lang=pug&"
import script from "./ParcelleInfos.vue?vue&type=script&lang=js&"
export * from "./ParcelleInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794aa7a",
  null
  
)

export default component.exports